import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getSpk } from "../../../../../Redux/reducer/env";
import QuestionsComponent from "../../../questions";
import StepControl from "./stepControl";
import Modal from "../../../../utils/customModal";
import { errorContainer, loadingHtml } from "../../../../utils/functions";
import ErrorIcon from "../../../../../../static/images/error-icon.svg";

export class Step3 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      questions: {
        question1: { id: 0, resp: "" },
        question2: { id: 0, resp: "" },
        question3: { id: 0, resp: "" },
      },
      errors: {
        question1: "",
        question2: "",
        question3: "",
      },
      modal: {
        show: false,
        type: "loading",
        modalMessage: { title: "", message: "" },
      },
    };
  }

  componentDidMount() {
    if (
      this.props.user.questions &&
      Object.keys(this.props.user.questions).length > 0
    ) {
      this.setState({ questions: this.props.user.questions });
    }
  }

  closeModal = () => {
    const { modal } = this.state;
    modal.show = false;
    modal.type = "loading";
    modal.modalMessage = { title: "", message: "" };
    this.setState({ modal });
  };

  getModalContent = () => {
    const { type, modalMessage } = this.state.modal;

    switch (type) {
      case "loading":
        return loadingHtml();
      case "error":
        return errorContainer(
          modalMessage.title,
          modalMessage.message,
          this.closeModal
        );
    }
  };

  handlerChange(event) {
    const value = event.target.value;
    const name = event.target.name;
    var { questions } = this.state;

    questions[name].resp = value;

    this.setState({ questions });
  }

  SelectedQuestion = (event) => {
    const value = event.target.value;
    const name = event.target.name;
    var { questions } = this.state;

    questions[name].id = value;

    this.setState({ questions });
  };

  getAnswers() {
    var valid = true;
    const { questions, errors } = this.state;

    // Ajustarlo a la forma de lista, 3 preguntas seleccionadas por el usuario
    // De momento se está validando con respecto a 3 preguntas quemadas
    Object.keys(questions).map((question) => {
      if (questions[question].resp == "") {
        errors[question] = "Debe contestar la pregunta";
        valid = false;
      } else {
        errors[question] = "";
      }
      this.setState({ errors });

      return true;
    });
    return valid;
  }

  submitForm() {
    const { questions, modal } = this.state;
    //validmos que estén las respuestas de las preguntas

    if (this.getAnswers()) {
      if (
        questions.question1.id !== questions.question2.id &&
        questions.question1.id !== questions.question3.id &&
        questions.question2.id !== questions.question3.id &&
        questions.question2.id !== questions.question1.id &&
        questions.question3.id !== questions.question2.id &&
        questions.question3.id !== questions.question1.id
      ) {
        modal.show = true;
        this.setState({ modal });

        this.props.submitStep(true, this.state.questions);
      } else {
        modal.show = true;
        this.setState({ modal });
        modal.modalMessage = {
          title: "Error",
          message: "Las preguntas no pueden ser repetidas",
        };

        modal.type = "error";
        this.setState({ modal });
      }
    }
  }

  displayError(id) {
    const { errors } = this.state;

    return errors[id] != "" ? (
      <div id="select-2-error" className="error">
        <span className="error__icon">
          <img src={ErrorIcon} alt="Error" />
        </span>
        <div className="error__text">{errors[id]}</div>
      </div>
    ) : null;
  }

  render() {
    var columnClasses = "col-lg-6 col-md-6 col-sm-12 col-12";
    const { modal } = this.state;

    return (
      <div id="step-3">
        <div className="security-questions">
          <h1>Defina 3 preguntas y respuestas de seguridad</h1>
          <div className="row">
            <div className={columnClasses}>
              <h3>Preguntas</h3>
            </div>
            <div className={columnClasses}>
              <h3>Respuestas</h3>
            </div>
          </div>
          <div key={`key-question-1`} className="row">
            <div className={`question ${columnClasses}`}>
              <QuestionsComponent
                name="question1"
                valueAttr={`id`}
                id="questionId1"
                value={this.state.questions.question1.id}
                onChange={(event) => this.SelectedQuestion(event)}
              />
            </div>
            <div className={`answer ${columnClasses}`}>
              <input
                type="text"
                id="question1"
                name="question1"
                className="input input--text input-w-aux__input input--active"
                value={this.state.questions.question1.resp}
                onChange={(event) => this.handlerChange(event)}
              />
              {this.displayError("question1")}
            </div>
          </div>
          <div key={`key-question-2`} className="row">
            <div className={`question ${columnClasses}`}>
              <QuestionsComponent
                name="question2"
                valueAttr={`id`}
                id="questionId2"
                value={this.state.questions.question2.id}
                onChange={(event) => this.SelectedQuestion(event)}
              />
            </div>
            <div className={`answer ${columnClasses}`}>
              <input
                type="text"
                id="question2"
                name="question2"
                className="input input--text input-w-aux__input input--active"
                value={this.state.questions.question2.resp}
                onChange={(event) => this.handlerChange(event)}
              />
              {this.displayError("question2")}
            </div>
          </div>
          <div key={`key-question-3`} className="row">
            <div className={`question ${columnClasses}`}>
              <QuestionsComponent
                name="question3"
                valueAttr={`id`}
                id="questionId3"
                value={this.state.questions.question3.id}
                onChange={(event) => this.SelectedQuestion(event)}
              />
            </div>
            <div className={`answer ${columnClasses}`}>
              <input
                type="text"
                id="question3"
                name="question3"
                className="input input--text input-w-aux__input input--active"
                value={this.state.questions.question3.resp}
                onChange={(event) => this.handlerChange(event)}
              />
              {this.displayError("question3")}
            </div>
          </div>

          <StepControl
            currentStep={3}
            submitStep={() => this.submitForm()}
            goBack={() => this.props.submitStep(false)}
          />
        </div>
        <Modal
          key={`provider-users`}
          show={modal.show}
          hideClose={modal.type == "loading"}
          handleClose={() => this.closeModal()}
        >
          {this.getModalContent()}
        </Modal>
      </div>
    );
  }
}

Step3.propTypes = {
  submitStep: PropTypes.func.isRequired,
};

export const mapStateToProps = (state) => {
  return {
    spk: getSpk(state),
    registerInfo: state.sessionInfoReducer.registerInfo,
  };
};

export default connect(
  mapStateToProps,
  null
)(Step3);
